import { THREE } from '@powerplay/common';
import { ParticleMaterialType } from './types';
export class ParticleObject {
    name;
    geometry;
    material;
    scene;
    mesh;
    HEIGHT;
    WIDTH;
    vertexShader = `
      uniform float pointMultiplier;
      attribute float rotation;
      attribute float scale;
      attribute float alpha;
      attribute vec2 offset;

      varying float vAlphaToFrag;
      varying float vRotation;
      varying vec2 vOffset;

      void main() {
        vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
        gl_Position = projectionMatrix * mvPosition;
        gl_PointSize = pointMultiplier * 1000.0 * scale / gl_Position.w;

        vAlphaToFrag = alpha;
        vRotation = rotation;
        vOffset = offset;
      }
    `;
    fragmentShader = `
      uniform sampler2D diffuseTexture;
      uniform vec2 repeat;

      varying float vAlphaToFrag;
      varying float vRotation;
      varying vec2 vOffset;

      void main() {
        float mid = 0.5;
        vec2 rotated = vec2(cos(vRotation) * (gl_PointCoord.x - mid)
                            + sin(vRotation) * (gl_PointCoord.y - mid) + mid,
                            cos(vRotation) * (gl_PointCoord.y - mid)
                            - sin(vRotation) * (gl_PointCoord.x - mid) + mid);

        vec4 text = texture2D(diffuseTexture, rotated * repeat + vOffset);

        gl_FragColor = text * vec4(1.0, 1.0, 1.0, vAlphaToFrag);
      }
    `;
    constructor(optionsCopy) {
        this.HEIGHT = optionsCopy.height;
        this.WIDTH = optionsCopy.width;
        this.name = optionsCopy.name;
        this.scene = optionsCopy.scene;
        this.geometry = new THREE.BufferGeometry();
        let repeatX = 1;
        let repeatY = 1;
        if (optionsCopy.repeat && optionsCopy.repeat[0])
            repeatX = optionsCopy.repeat[0];
        if (optionsCopy.repeat && optionsCopy.repeat[1])
            repeatY = optionsCopy.repeat[1];
        if (optionsCopy.materialType === ParticleMaterialType.shader) {
            this.material = new THREE.ShaderMaterial({
                uniforms: {
                    diffuseTexture: { value: optionsCopy.texture },
                    pointMultiplier: { value: this.HEIGHT / this.WIDTH },
                    repeat: {
                        value: new THREE.Vector2(1 / repeatX, 1 / repeatY)
                    }
                },
                vertexShader: this.vertexShader,
                fragmentShader: this.fragmentShader,
                blending: optionsCopy.blending,
                depthTest: optionsCopy.depthTest,
                depthWrite: optionsCopy.depthWrite,
                transparent: optionsCopy.transparent,
                vertexColors: optionsCopy.vertexColors
            });
        }
        else {
            this.material = new THREE.PointsMaterial({
                color: optionsCopy.color,
                map: optionsCopy.texture,
                alphaMap: optionsCopy.alphaMap,
                size: optionsCopy.size,
                sizeAttenuation: optionsCopy.sizeAttenuation,
                depthTest: optionsCopy.depthTest,
                depthWrite: optionsCopy.depthWrite,
                transparent: optionsCopy.transparent
            });
        }
        this.mesh = new THREE.Points(this.geometry, this.material);
        this.mesh.name = this.name;
        this.mesh.frustumCulled = false;
        this.scene.add(this.mesh);
        if (optionsCopy.position) {
            this.setMeshPosition(this.mesh, optionsCopy.position);
        }
    }
    getName() {
        return this.name;
    }
    getMesh() {
        return this.mesh;
    }
    removeParticle() {
        this.mesh.visible = false;
    }
    getGeometry() {
        return this.geometry;
    }
    getMaterial() {
        return this.material;
    }
    setMeshPosition(mesh, position) {
        mesh.position.x = position.x;
        mesh.position.y = position.y;
        mesh.position.z = position.z;
    }
}
//# sourceMappingURL=ParticleObject.js.map